import { CoordinationStatus } from 'src/utils/CoordinationStatus'

export interface IDashboardSearchRequest {
  patientFirstName: string | undefined
  patientLastName: string | undefined
  apptDateStart: string | undefined
  apptDateEnd: string | undefined
  providerGroupName: string | undefined
  componentId: string | undefined
  coordinatorId: string | undefined
  includeTBD?: boolean
  eocLegacy?: string | undefined
  invoiceSurgeryStatus?: string | undefined
  coordinationStatus?: CoordinationStatus | undefined
  priority?: number | undefined
  isOverdue?: boolean
  page?: number
  pageSize?: number
}

export class DashboardSearchRequest implements IDashboardSearchRequest {
  public patientFirstName: string | undefined
  public patientLastName: string | undefined
  public apptDateStart: string | undefined
  public apptDateEnd: string | undefined
  public providerGroupName: string | undefined
  public componentId: string | undefined
  public coordinatorId: string | undefined
  public includeTBD?: boolean
  public eocLegacy?: string | undefined
  public invoiceSurgeryStatus?: string | undefined
  public coordinationStatus?: CoordinationStatus | undefined
  public priority?: number | undefined
  public isOverdue?: boolean
  public page?: number | undefined
  public pageSize?: number | undefined
}
